export class GetKxAccommodationOffersForApplicantRequest {
    StudentID: string;
    AcademicYearID: number;
    ApplicationTypeID: number;
}